module.exports = __webpack_public_path__ + "static/media/sample.1c310399.pdf";